export default "__VITE_ASSET__D5J1vqHy__"